import { Spacer } from "@nextui-org/spacer";
import { useMemo } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Container, SpicyButton, Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import useAuth from "@/services/useAuth";

export default function UserNotFound() {
  const { logout } = useAuth();
  const transComponents = useMemo(() => ({ logoutLink: <a className="text-link mx-1" onClick={logout} /> }), [logout]);

  return (
    <>
      <PageStaticMetaTags pageId="notFound" />
      <section className="section-404 absolute top-[45%] left-[50%] translate-x-[-50%] translate-y-[-50%] leading-6 max-sm:2.5">
        <Container className="text-center mb-[0.625rem]">
          <Text h1>
            <Trans i18nKey="user:userNotFound.title" />
          </Text>
        </Container>
        <Container className="flex flex-col items-center justify-center text-center">
          <Text variant={"xxl"}>
            <span className="leading-[36px]">
              <Trans i18nKey="user:userNotFound.description" />
            </span>
          </Text>
          <Spacer y={1} />
          <Text variant={"lg"}>
            <span className="leading-[30px]">
              <Trans i18nKey="user:userNotFound.logoutPrompt" components={transComponents} />
            </span>
          </Text>
          <LocalizedLink className="mt-[0.62]" to="/" aria-label="home">
            <SpicyButton variant="primary_large" color="primary_strong" onPress={logout}>
              <Trans i18nKey="user:userNotFound.cta.backToHome" />
            </SpicyButton>
          </LocalizedLink>
        </Container>
      </section>
    </>
  );
}
